// Webpack Imports
import 'bootstrap';
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';


( function ( $ ) {
	'use strict';

	// Focus input if Searchform is empty
	$( '.search-form' ).on( 'submit', function ( e ) {
		var search = $( this ).find( 'input' );
		if ( search.val().length < 1 ) {
			e.preventDefault();
			search.trigger( 'focus' );
		}
	} );
	$('.btn-bars').on('click', function(){
		if ($('body').hasClass('is-animating')) {
			return false;
		}
		$('body').addClass('is-animating')
		$('body').toggleClass('modal-open menu-open')
		$(this).toggleClass('is-open')
		setTimeout(function(){
			$('body').removeClass('is-animating')				
		}, 650);
		return false;
	})
	$( '.scrollto' ).on( 'click', function ( e ) {
		var anchor = $( this ).data('anchor');
		console.log(anchor)
		if ( $('#' + anchor ).length ) {
			$("html, body").animate({scrollTop: $('#' + anchor).offset().top}, 1000, "swing");
			if ($('body').hasClass('modal-open')) {
				$('.btn-bars').click()
			}
	    return false
		} else {
			return true
		}
	});
  $('.modal').on('show.bs.modal', function (e) {
    $('body').addClass('hide-bars')
  })
  $('.modal').on('hide.bs.modal', function (e) {
		if ($(this).attr('id') == 'youtubeModal') {
			$(this).find('iframe').remove()
		}
    $('body').removeClass('hide-bars')
  })

}( jQuery ) );
